import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { notificationsAPI } from '../lib/api';
import { useEffect, useState } from 'react';

/**
 * Floating Action Button — scorciatoia verso /chat.
 * Mostra il numero di notifiche chat non lette.
 * Non compare sulla pagina /chat stessa.
 */
export const ChatFab = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    fetchUnread();
    const id = setInterval(fetchUnread, 15000);
    return () => clearInterval(id);
  }, []);

  const fetchUnread = async () => {
    try {
      const res = await notificationsAPI.getAll();
      const chatUnread = res.data.filter(
        n => !n.letta && n.link?.startsWith('/chat')
      ).length;
      setUnread(chatUnread);
    } catch {}
  };

  // Nascondi sulla pagina chat
  if (location.pathname === '/chat') return null;

  return (
    <button
      onClick={() => navigate('/chat')}
      aria-label="Apri Chat"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 text-white shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 active:scale-95"
    >
      <MessageSquare className="h-6 w-6" />
      {unread > 0 && (
        <span className="absolute -top-1 -right-1 flex items-center justify-center min-w-[20px] h-5 px-1 rounded-full bg-red-500 text-white text-xs font-bold leading-none border-2 border-white">
          {unread > 9 ? '9+' : unread}
        </span>
      )}
    </button>
  );
};
